import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AppContextProvider } from 'src/context/appContext';
import { LanguageContextProvider } from 'src/context/languageContext';
import { MarketProvider } from 'src/context/marketContext';
import Routes from './routes';
import './App.scss';
import Head from './conponents/Head';

function App() {
  return (
    <div className="app-container">
      <LanguageContextProvider>
        <Head />
        <AppContextProvider>
          <MarketProvider>
            <Router>
              <Routes />
            </Router>
          </MarketProvider>
        </AppContextProvider>
      </LanguageContextProvider>
    </div>
  );
}

export default App;
